import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { SearchFieldModule } from '@hdms/shared/ui-core';

import { HeaderSearchInputComponent } from './search-input.component';

@NgModule({
  declarations: [HeaderSearchInputComponent],
  imports: [CommonModule, TranslationModule, SearchFieldModule],
  exports: [HeaderSearchInputComponent]
})
export class HeaderSearchInputModule {}
